import React from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import {
    CountryGetLocalization,
    FieldGetLocalization,
    SingleGetLocalization,
    Organization,
} from '../../../services/interfaces/schedule.interface/schedule.getlocalizationdata.interface'
import { request_get_localization_data } from '../../../services/schedule.services'
import { schedulesServices } from '../../../../database/schedules.database'
import { validateConnectionNetwork } from '../../../utils/functions.utils'
import { getCountryId } from '../../../../db-sqlite/repositories/user.repository'

export const COUNTRY_ID_ARG = '6463ddc820bc52c864a6cab4'
export const COUNTRY_ID_MEX = '637e3c916d22752787878f41'

export const useCreateStore = () => {

    const getAndSaveDataGeolocalization = async () => {
        try {
            const hasConnection = await validateConnectionNetwork()

            if (!hasConnection) {
                console.error('getAndSaveDataGeolocalization - No hay conexión a internet')
                return
            }

            // ✅ Verificar si ya existe data en la DB local antes de hacer el request
            const hasDataInDB = await checkIfDataExistsInDB()
            if (hasDataInDB) {
                console.log('✅ getAndSaveDataGeolocalization - Data ya existe en DB local, omitiendo request')
                return
            }

            console.log('🔄 getAndSaveDataGeolocalization - No hay data en DB, haciendo request...')
            const data = await getLocalization()
            // console.log('getAndSaveDataGeolocalization - data received:', data)

            await saveDateInDb(data)
        } catch (error) {
            console.error('getAndSaveDataGeolocalization => ', error)
        }
    }

    const checkIfDataExistsInDB = async (): Promise<boolean> => {
        try {
            // Verificar si existen fields en la DB
            const fields = await schedulesServices.getFieldsCreatePos()
            
            if (fields && fields.length > 0) {
                console.log(`✅ checkIfDataExistsInDB - Se encontraron ${fields.length} fields en DB`)
                return true
            }
            
            console.log('⚠️ checkIfDataExistsInDB - No se encontraron fields en DB')
            return false
        } catch (error) {
            console.error('checkIfDataExistsInDB error => ', error)
            return false
        }
    }

    const getLocalization = async (): Promise<SingleGetLocalization> => {
        //* verificar si existe en la db local, sino hacer la request
        let dataRequestGeo = null
        const session = await fetchAuthSession()
        const authToken = session.tokens?.accessToken?.toString() || ""
        const country_id = await getCountryId()

        const data = {
            authToken,
            country_id,
        }

        const response = await request_get_localization_data(data)

        if (response && response.status == 1) {
            dataRequestGeo = response.single
        }
        return dataRequestGeo
    }

    const saveDateInDb = async (data: SingleGetLocalization) => {
        try {
            // console.log('saveDateInDb - data to save ============> :', data)
            // if (!data || !data.fields || !data.fields_organization || !data.country || !data.organizations) {
            //     console.error('saveDateInDb - Datos incompletos', data)
            //     return
            // }

            if (!data || !data.fields) {
                console.error('saveDateInDb - Datos incompletos', data)
                return
            }

            // si me llega la key city o province
            const hasCityField = data.fields.some(field => field.name === 'city')
            const hasProvinceField = data.fields.some(field => field.name === 'province')
            const hasOrganizationField = data.fields.some(field => field.name === 'organization')

            console.log('validation => ', data.fields.some(field => field.name === 'city'))
            // console.log('fields => ', data.fields)
            console.log('saveDateInDb - hasCityField:', hasCityField)
            console.log('saveDateInDb - hasProvinceField:', hasProvinceField)
            console.log('saveDateInDb - hasOrganizationField:', hasOrganizationField)

            await saveFields(data.fields)

            if (hasCityField && hasProvinceField) await saveCountry(data.country)
            if (hasOrganizationField) await saveFields(data.fields_organization, true)
            if (hasOrganizationField) await saveOrganizations(data.organizations)

        } catch (error) {
            console.error('saveDateInDb => ', error)
        }
    }

    const saveFields = async (fields: FieldGetLocalization[], organization = false) => {
        try {
            if (fields.length === 0) {
                console.warn('saveFields - No hay campos para guardar')
                return
            }
            if (organization) {
                await schedulesServices.saveFieldsOrganizationCreatePos(fields)
            } else {
                // console.log('---------------------- saveFields - Saving fields:', fields)
                await schedulesServices.saveFieldsCreatePos(fields)
            }
        } catch (error) {
            console.error('saveFields error => ', error)
        }
    }

    const saveOrganizations = async (organizations: Organization[]) => {
        try {
            await schedulesServices.addOrganizaciones(organizations)
        } catch (error) {
            console.error('saveOrganizations error => ', error)
        }
    }

    const saveCountry = async (country: CountryGetLocalization) => {
        try {
            if (country) await schedulesServices.saveCountryData(country)
        } catch (error) {
            console.error('saveCountry error => ', error)
        }
    }

    return {
        getAndSaveDataGeolocalization,
    }
}
